







import { Prop, Component, Vue } from "vue-property-decorator";
import Spinner from "vue-spinkit";
import { UserAgentHelper } from "@/helper/userAgentHelper"

@Component({
    components: {
        Spinner
    }
})
export default class VSpinner extends Vue {
    @Prop({ default: "circle" }) type!: string;

    get color(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    get browser(): string{
        return UserAgentHelper.getBrowser()
    }

    get onIE(): boolean {
        return this.browser === "ie";
    }
}
